module.exports = __webpack_public_path__ + "d0e406dbd60cfabdb09a1f08517523c6.xlsx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/Tecon_Rio_Grande_Lista_Destino_Final.xlsx
// module id = ./src/assets/downloads/Tecon_Rio_Grande_Lista_Destino_Final.xlsx
// module chunks = 1